import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../auth/auth.service';
import {ToastrService} from 'ngx-toastr';
import {LanguageService} from '../../services/language.service';
import {CardConditionService} from '../../services/card-condition.service';
import {Card, Edition, PriceRule} from '../../core/entities/entities';
import {EditionService} from '../../services/edition.service';
import {NowComponentBase} from '../../shared/base/NowComponentBase';
import {ActivatedRoute, Router} from '@angular/router';
import {PriceRuleService} from '../../services/price-rule.service';

@Component({
  selector: 'app-price-rule-add-table',
  templateUrl: './price-rule-add-table.component.html',
  styleUrls: ['./price-rule-add-table.component.css']
})
export class PriceRuleAddTableComponent extends NowComponentBase implements OnInit, OnDestroy {


  private _edition: Edition;

  get editionDetail() {
    return this._edition;
  }

  private totalMovements = 0;

  public userIsAdmin = false;

  get totMovCount() {
    return this.totalMovements;
  }


  getCodePattern(data: any[]) {
    return data.reduce((tot, item) => {
      if (tot.length > 0) {
        tot = tot + '|';
      }
      tot = tot + item.code;
      return tot;
    }, '');

  }

  delete(movIndex: number) {
    this.getDetail().splice(movIndex, 1);
    this.calculateMovements();
  }

  //per i totali..
  curItem: PriceRule = new PriceRule();

  clone(item: PriceRule, index: number) {
    this.getDetail().splice(index, 0, this.priceRuleService.clone(Object.assign(new PriceRule(), item)));
    this.calculateMovements();
  }

  remove(item: PriceRule, index: number) {
    this.getDetail().splice(index, 1);
    this.calculateMovements();
  }

  getWrap(item: PriceRule) {
    const me = this;
    return {
      set language(code: string) {
        item.combination.language = me.languageService.data.find(w => code && w.code.toLowerCase() == code.toLowerCase());
        me.calculateMovements();
      },

      get language() {
        return item.combination.language && item.combination.language.code ? item.combination.language.code : null;
      },

      set holo(id: any) {
        item.combination.holo = me.holoService.data.find(w => id && w.code == id);
        me.masterChange();
      },

      get holo() {
        return item.combination.holo && item.combination.holo.code ? item.combination.holo.code : null;
      },

      set cardCondition(code: string) {
        item.combination.condition = me.cardCondtionService.data.find(w => code && w.code.toLowerCase() == code.toLowerCase());
        me.calculateMovements();
      },

      get cardCondition() {
        return item.combination.condition && item.combination.condition.code ? item.combination.condition.code : null;
      },

      set price(price: number) {
        item.price = price;
        console.log(price);
        me.calculateMovements();
      },

      get price() {
        return item.price;
      },

      set minRule(minRule: boolean) {
        item.minRule = minRule;
        me.calculateMovements();
      },

      get minRule() {
        return item.minRule;
      },

      set maxRule(maxRule: boolean) {
        item.maxRule = maxRule;
        me.calculateMovements();
      },

      get maxRule() {
        return item.maxRule;
      },

      set maxPrice(maxPrice: number) {
        item.maxPrice = maxPrice;
        me.calculateMovements();
      },

      get maxPrice() {
        return item.maxPrice;
      }


    };
  }


  curItemWrap = this.getCurItemWrap();

  getCurItemWrap() {
    const me = this;
    return {
      // totali
      set language(code: string) {
        me.curItem.combination.language = me.languageService.data.find(w => code && w.code.toLowerCase() == code.toLowerCase());
        me.masterChange();
      },

      get language() {
        return me.curItem.combination.language && me.curItem.combination.language.code ? me.curItem.combination.language.code : null;
      },

      set holo(id: any) {
        me.curItem.combination.holo = me.holoService.data.find(w => id && w.code == id);
        me.masterChange();
      },

      get holo() {
        return me.curItem.combination.holo && me.curItem.combination.holo.code ? me.curItem.combination.holo.code : null;
      },

      set cardCondition(code: string) {
        me.curItem.combination.condition = me.cardCondtionService.data.find(w => code && w.code.toLowerCase() == code.toLowerCase());
        me.masterChange();
      },

      get cardCondition() {
        return me.curItem.combination.condition && me.curItem.combination.condition.code ? me.curItem.combination.condition.code : null;
      },


      set signed(signed: boolean) {
        me.curItem.combination.signed = signed;
        me.masterChange();
      },

      get signed() {
        return me.curItem.combination.signed;
      },

      set stamped(stamped: boolean) {
        me.curItem.combination.stamped = stamped;
        me.masterChange();
      },

      get stamped() {
        return me.curItem.combination.stamped;
      },

      set inked(inked: boolean) {
        me.curItem.combination.inked = inked;
        me.masterChange();
      },

      get inked() {
        return me.curItem.combination.inked;
      },

      set altered(altered: boolean) {
        me.curItem.combination.altered = altered;
        me.masterChange();
      },

      get altered() {
        return me.curItem.combination.altered;
      },

      set foil(foil: boolean) {
        me.curItem.combination.foil = foil;
        me.masterChange();
      },

      get foil() {
        return me.curItem.combination.foil;
      },

      set firstEdition(firstEdition: boolean) {
        me.curItem.combination.firstEdition = firstEdition;
        me.masterChange();
      },

      get shadowless() {
        return me.curItem.combination.shadowless;
      },

      set shadowless(shadowless: boolean) {
        me.curItem.combination.shadowless = shadowless;
        me.masterChange();
      },

      get staff() {
        return me.curItem.combination.staff;
      },

      set staff(staff: boolean) {
        me.curItem.combination.staff = staff;
        me.masterChange();
      },

      get firstEdition() {
        return me.curItem.combination.firstEdition;
      },

      get selected() {
        return me.curItem.selected;
      },

      set selected(selected: boolean) {
        me.curItem.selected = selected;
        me.selectionChange();
      },

      set price(price: number) {
        me.curItem.price = price;
        me.masterChange();
      },

      get price() {
        return me.curItem.price;
      },

      set minRule(minRule: boolean) {
        me.curItem.minRule = minRule;
        me.masterChange();
      },

      get minRule() {
        return me.curItem.minRule;
      },

      set maxRule(maxRule: boolean) {
        me.curItem.maxRule = maxRule;
        me.masterChange();
      },

      get maxRule() {
        return me.curItem.maxRule;
      },

      set maxPrice(maxPrice: number) {
        me.curItem.maxPrice = maxPrice;
        me.masterChange();
      },

      get maxPrice() {
        return me.curItem.maxPrice;
      }
    };
  }

  masterChange() {

  }

  selectionChange() {
    this.getDetail().forEach(c => c.selected = this.curItem.selected);
    this.masterChange();
  }

  get languages() {
    return this.languageService.dataChange;
  }

  get conditions() {
    return this.cardCondtionService.dataChange;
  }

  applyAll() {
    this.spinnerService.show();
    const me = this;
    this.getDetail().filter(c => c.selected).forEach(c => {
// -
      c.combination.condition = me.curItem.combination.condition ;
      c.combination.foil = me.curItem.combination.foil;
      c.combination.firstEdition = me.curItem.combination.firstEdition;
      c.combination.shadowless = me.curItem.combination.shadowless;
      c.combination.staff = me.curItem.combination.staff;
      c.combination.altered = me.curItem.combination.altered;
      c.combination.inked = me.curItem.combination.inked;
      c.combination.holo = me.curItem.combination.holo;
      c.combination.signed = me.curItem.combination.signed;
      c.combination.stamped = me.curItem.combination.stamped;

      c.combination.language = me.curItem.combination.language;
      c.price = me.curItem.price;

      c.minRule = me.curItem.minRule;
      c.maxRule = me.curItem.maxRule;
      c.maxPrice = me.curItem.maxPrice;

    });
    this.calculateMovements();
    this.spinnerService.hide();
  }

  private _cards: Card[];
  get cards() {
    return this._cards;
  }

  private details: PriceRule[];

  public getDetail(): PriceRule[] {
    if (!this.details) {
      return [];
    }
    return this.details;
  }



  private getValidList() {
    const me = this;
    return me.getDetail().filter( ri => {
      return me.isValidRule(ri)
    }).map(r => {
      return r;
    });
  }

  private isValidRule(ri: PriceRule): boolean {

    if ( isNaN(ri.price)  || ri.price < 0 || (ri.price == null) ){
      return false;
    }

    if (ri.maxRule == true && ri.minRule == false){
       ri.maxRule = false;
    }

    if ( ri.maxRule == true  &&  (this.isNull(ri.maxPrice) || ri.price > ri.maxPrice)){
      return false;
    }

    return true;
  }

  private calculateMovements() {
    this.totalMovements = this.getValidList().length;
  }



  constructor(private _editionServ: EditionService,
    private _activeRoute: ActivatedRoute,
    public languageService: LanguageService,
    public priceRuleService: PriceRuleService,
    public cardCondtionService: CardConditionService,
    private _toastrService: ToastrService,
    private _router: Router,
    private _authService: AuthService) {
    super();

    this.userIsAdmin = this._authService.hasProfile('admin');
  }

  private loadCards(ret: Card[]) {
    this._cards = ret;
    this.details = ret.map(c => {
      return Object.assign(new PriceRule(), {
        cardData: {
          image: c.imageName,
          categoryName : c.categoryName,
          name: c.name,
          edition: c.edition,
        }, cardId: c.id,
      });
    });

    this.spinnerService.hide();

  }



  saveAll() {
    const me = this;
    this.spinnerService.show();
    this.priceRuleService.saveAll(me.getValidList().map( r => {

      const ret: any = Object.assign({}, r, r.combination);
      if (r.combination.condition) {
        ret.conditionId = r.combination.condition.id;
     }
     if (r.combination.language) {
       ret.languageId = r.combination.language.id;
     }

      if (r.combination.holo) {
        ret.holoId = r.combination.holo.id;
      }

     return ret;

    })).subscribe(() => {
      this._toastrService.success('Eseguito Correttamente!');
      this._router.navigateByUrl('/home/price_rules');
      this.spinnerService.hide();
    });


  }

  ngOnInit() {
    super.ngOnInit();
    this.details = [];
    const me = this;
    this.spinnerService.show();
    this._activeRoute.params.subscribe((params) => {
      this._editionServ.loadById(params['expansionId']).subscribe( ed => this._edition = ed);
      this._editionServ.getSetNew(params['categoryId'], params['brandId'], params['expansionId'], params['rarityId'] && params['rarityId'] > 0 ? params['rarityId'] : undefined ).subscribe(ret => this.loadCards(ret.content));
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}




// WEBPACK FOOTER //
// ./src/app/conf/price-rule-add-table/price-rule-add-table.component.ts